import { UserState } from "../types/userTypes";
import { AnyAction } from "redux";
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_RESET,
} from "../actions/userActions";

const initialState: UserState = {
  users: null,
  loading: false,
  error: null,
};

const userReducer = (state = initialState, action: AnyAction): UserState => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USERS_SUCCESS:
      return { ...state, users: action.payload, loading: false, error: null };
    case FETCH_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_USERS_RESET:
      return { ...state, users: null, loading: false, error: null };
    // Handle other user-related actions here...
    default:
      return state;
  }
};

export default userReducer;
